import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { StoreCategory } from '../types/store';
import { getPosition } from '../store/slices/locationSlice';
import { getTranslatableStoreOpenStatus, isStoreOpen } from '../utils/store';
import { getSelectedStore, selectStore as selectStoreReducer } from '../store/slices/storesSlice';
const StoreListItem = ({ source }) => {
    const { t } = useTranslation();
    const position = useSelector(getPosition);
    const selectedStore = useSelector(getSelectedStore);
    const dispatch = useDispatch();
    const distance = useMemo(() => {
        return Math.round(source.distanceToPosition || 0);
    }, [source]);
    const icon = useMemo(() => {
        // eslint-disable-next-line import/no-dynamic-require
        const storeCategory = StoreCategory;
        // eslint-disable-next-line import/no-dynamic-require
        return require(`../../../../img/store-locator/icon-marker-${source.reseller ? storeCategory.Iqos : source.category}-small.svg`);
    }, [source]);
    const openStatusString = useMemo(() => {
        const translatable = getTranslatableStoreOpenStatus(source, new Date());
        return translatable && t(translatable.key, translatable.parameters);
    }, [source]);
    const isOpen = useMemo(() => {
        return isStoreOpen(source, new Date());
    }, [source]);
    const isActive = selectedStore && selectedStore.id === source.id;
    const select = () => {
        dispatch(selectStoreReducer(source));
        window.dataLayer.push({
            event: 'storeLocatorStoreClick',
            storeLocatorStoreID: source.id,
            storeLocatorStoreName: source.name,
            storeLocatorStoreType: source.category,
            storeLocatorStoreClickSource: 'List',
        });
    };
    return (_jsx("div", { role: "listitem", children: _jsxs("div", { className: `list-group-item list-group-item-action list-group-item-arrowed-right border-bottom-0 cursor-pointer ${isActive ? 'active' : ''}`, onClick: select, children: [_jsxs("div", { className: "mb-1 font-weight-bold", children: [_jsx("img", { src: icon, className: "mr-1", width: "24", height: "32" }), source.name] }), openStatusString && (_jsx("div", { className: `font-size-extra-small mb-1 ${!isOpen ? 'text-red' : ''}`, children: openStatusString })), _jsxs("div", { className: "font-size-extra-small", children: [position && _jsxs(_Fragment, { children: [distance, " km - "] }), source.address] })] }) }));
};
export default StoreListItem;
